import React, { useState, useEffect } from 'react'
import Bundles from './Bundles/Bundles'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import CheckboxToggle from 'components/ContentBox/Global/CheckboxToggle/CheckboxToggle'
import { superAxiosRequest } from 'axiosApi'
import { classNames as cn } from 'helpers'
import { localisationMaster } from 'Localisation/Localisation'
import Error from '../Error/Error'
import './Ligaments.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'
import { ReactComponent as AddLine } from 'components/UI/icons/add-line.svg'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalization from 'hooks/useLocalization'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'

const Ligaments = ({
  setForm,
  form,
  validate,
  optionsBundle,
  setOptionsBundle,
  bundleRef,
}) => {
  const [bundles, setBundldes] = useState({ data: [], loading: true })
  const history = useHistory()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [filter, updateFilter] = useLocalStorageFilter()

  const filterCnf = [
    {
      type: 'select',
      apiLink: 'db/age',
      value: filter?.name,
      label: localisationMaster(
        'text_17',
        'c/tests/placement-test/create-widget',
      ),
      placeholder: localisationMaster(
        'text_17',
        'c/tests/placement-test/create-widget',
      ),
      nameState: 'age',
    },
    {
      type: 'select',
      apiLink: 'db/programs',
      label: localisationMaster(
        'placeholder-10',
        'online-schedule/record-customer',
      ),
      placeholder: localisationMaster(
        'placeholder-10',
        'online-schedule/record-customer',
      ),
      value: filter?.name,
      nameState: 'program',
    },
  ]
  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
    },
  })

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'placement_test/bundles',
    })
      .then(({ data }) => {
        setBundldes({ loading: false, data: data.result })
      })
      .catch(() => setBundldes({ data: [], loading: false }))
  }, [])

  const removeBundle = (id) => {
    const result = form.bundles.filter((item) => id !== item.id)
    setForm({ ...form, bundles: result })
  }

  const getBundles = (params) => {
    const array = Object.entries(params || {})
    const queryParams = Object.fromEntries(
      array.filter(([key, value]) => value),
    )
    setBundldes({ ...bundles, loading: true })
    superAxiosRequest({
      method: 'get',
      link: 'placement_test/bundles',
      params: queryParams,
    })
      .then(({ data }) => {
        setBundldes({ loading: false, data: data.result })
      })
      .catch(() => setBundldes({ data: [], loading: false }))
  }

  useEffect(() => {
    const params = {
      ...filter,
    }
    getBundles(params)
  }, [filter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/dropped_students') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  return (
    <div className='placementTestBoxLigaments' ref={bundleRef}>
      <div className='placementTestCreate__ligaments'>
        <div className='placementTestBox__mainBoxLine'>
          <p className='placementTestBox__title'>
            {localisationMaster(
              'text_15',
              'c/tests/placement-test/create-widget',
            )}{' '}
          </p>
        </div>
        <div className='placementTestBox__mainBoxLigaments'>
          <div className='placementTestBox__titleOption'>
            <div className='placementTestBox__titleInput'>
              <FormField>
                <FormLabel>Заголовок</FormLabel>
                <FormInput>
                  <input
                    type='text'
                    className={cn({
                      placementTestBox__input: true,
                      'placementTestBox__input--error':
                        validate('bundle') && !optionsBundle.placeholder.length
                          ? true
                          : false,
                    })}
                    value={optionsBundle.placeholder}
                    onChange={(e) =>
                      setOptionsBundle({
                        ...optionsBundle,
                        placeholder: e.target.value,
                      })
                    }
                  />
                </FormInput>
              </FormField>
            </div>
            <div className='placementTestBox__bundleRequired'>
              <CheckboxToggle
                right={'Объязательное поле'}
                onChange={() =>
                  setOptionsBundle({
                    ...optionsBundle,
                    selected: !optionsBundle.selected,
                  })
                }
                checked={optionsBundle.selected}
              />
            </div>
          </div>
        </div>
        <div className='placementTestBox__mainBoxLine'>
          <p className='placementTestBox__subtitle'>
            {localisationMaster(
              'text_29',
              'c/tests/placement-test/create-widget',
            )}
            :
          </p>
        </div>
        <div className='placementTestBox_mainBoxLine'>
          {validate('bundles') ? (
            <Error
              text={localisationMaster(
                'error_bundles',
                'c/tests/placement-test/create-widget',
              )}
            />
          ) : null}
        </div>
        <div className='placementTestBox__ligamnetsBundles'>
          {!form.bundles.length ? (
            <div className='sg-probka'>
              {localisationMaster(
                'warning',
                'c/tests/placement-test/create-widget',
              )}
            </div>
          ) : (
            form.bundles.map((item) => {
              const checked = form.bundles.some((el) => el.id === item.id)
              return (
                <Bundles
                  key={item.id}
                  {...item}
                  added
                  icon={() => (
                    <ToggleCheckbox
                      checked={checked}
                      reverse
                      onChange={() => removeBundle(item.id)}
                    />
                  )}
                />
              )
            })
          )}
        </div>
        <div className='placementTestBox__filter'>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, search: text })
              changeTextValue('search', {
                key: 'search',
                label: 'Search',
                value: text,
              })
            }}
            onClear={() => {
              const { search, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'search'),
              )
            }}
            translate={translate}
            placeholder={`Search...`}
            value={filter?.search || ''}
          />
          {!!filterTextValues.length && (
            <FilterTextValues
              onDelete={(key) => {
                const { [key]: _, ...obj } = filter
                updateFilter(obj)
              }}
            />
          )}
          {isOpenFilter && (
            <AsideFilter
              translate={translate}
              getFilterParams={updateFilter}
              config={filterCnf}
              filterValue={filter}
              onDropFilter={() => {
                updateFilter({})
                closeFilter()
              }}
            />
          )}
        </div>
        <div className='placementTestBox__ligamnetsBundles'>
          {bundles.loading ? (
            <Loader />
          ) : bundles.data.length === 0 ? (
            <div className='sg-probka'>
              {localisationMaster(
                'warning',
                'c/tests/placement-test/create-widget',
              )}
            </div>
          ) : (
            bundles.data
              .filter((item) => !form.bundles.some((el) => el.id === item.id))
              .map((item) => (
                <Bundles
                  key={item.id}
                  {...item}
                  icon={() => (
                    <div
                      onClick={() =>
                        setForm({
                          ...form,
                          bundles: [...form.bundles, item],
                        })
                      }
                    >
                      <AddLine />
                    </div>
                  )}
                />
              ))
          )}
        </div>
      </div>
    </div>
  )
}

export default observer(Ligaments)
